import config from '@/config'
import { ajax } from 'gkSrc/utils/request'

export default {
  // 获取讲堂数据
  getColumns (data) {
    return ajax({
      headers: {
        'content-type': 'text/plain'
      },
      host: config.timeHost,
      url: '/serv/v2/explore/list',
      data
    })
  }
}
